
export const API_URL_PATHS = {
  apiUrl: `${process.env.REACT_APP_API_BASE_URL}/api`,
  loginUrl: `${process.env.REACT_APP_API_BASE_URL}/login`,
  verifyTokenUrl: `${process.env.REACT_APP_API_BASE_URL}/api/users/user`,
  logoutUrl: `${process.env.REACT_APP_API_BASE_URL}/api/users/logout`,
  instructionsUrl: `${process.env.REACT_APP_CADESS_API_URL}/instructions`,
  cadessUrl: `${process.env.REACT_APP_CADESS_API_URL}`,

};


export const CADESS_API_CONFIG = {
  auth: {
    username: `${process.env.REACT_APP_CADESS_API_USERNAME}`,
    password: `${process.env.REACT_APP_CADESS_API_PASSWORD}`,
  },
};

export const CADESS_API_SPECIMEN_STATUS = `${process.env.REACT_APP_CADESS_API_URL}/specimen/status`;

export const CADESS_API_CASE_STATUS = `${process.env.REACT_APP_CADESS_API_URL}/case/status`;